<template lang="pug">
  v-select.package-select(:value="selectedOption" @input="onInput" :options="options" label="name" :placeholder="loading ? 'Loading...' : placeholder" :disabled="loading || disabled")
</template>
<script>
import vSelect from 'vue-select'
import Masterdata from '@/service/apis/Masterdata'

export default {
  props: {
    value: {
      type: Number,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    loading: false,
    options: [],
    placeholder: 'Select A Package',
    selectedOption: null
  }),
  created() {
    this.loading = true
    Masterdata.listPackageTypes({ size: 1000 }) // FIXME.. check response if there are more then 1000 packages
      .then((resp) => {
        this.options = resp.data.content
        this.updateSelectedOption()
      })
      .catch((e) => { this.placeholder = e.response.data.message })
      .then(this.loading = false)
  },
  methods: {
    updateSelectedOption() {
      if (this.value) {
        this.selectedOption = this.options.find((o) => o.id === this.value)
      } else {
        this.selectedOption = null
      }
    },
    onInput(val) {
      this.$emit('input', val ? val.id : null)
    },
    getSelectedPackage() {
      return this.selectedOption
    },
    setSelectedPackage(packageType) {
      const exisiting = this.options.find((o) => o.id === packageType.id)
      if (!exisiting) {
        this.options.push(packageType)
      }
    }
  },
  watch: {
    value() {
      this.updateSelectedOption()
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/PackageSelect.vue